module.exports = __webpack_public_path__ + "static/mapa colores-a15f0bdb08b947118c194f995b515c82.jpg";